import { render, staticRenderFns } from "./Fkoffprocess.vue?vue&type=template&id=48b2fe64&scoped=true&"
import script from "./Fkoffprocess.vue?vue&type=script&lang=js&"
export * from "./Fkoffprocess.vue?vue&type=script&lang=js&"
import style0 from "./Fkoffprocess.vue?vue&type=style&index=0&id=48b2fe64&scoped=true&lang=css&"
import style1 from "./Fkoffprocess.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2fe64",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCard,QCardSection,QTimeline,QTimelineEntry,QChip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCard,QCardSection,QTimeline,QTimelineEntry,QChip})
